import { RepeatIcon, DownloadIcon } from "@chakra-ui/icons";
import { Button, Flex, Heading, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputSearch from "components/elements/InputSearch/input-search";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { CSVLink } from "react-csv";
import { DataTableConfig } from "./types/data-table.config";

export function DataTableActions<T>({
  hideHeader = false,
  hideSearch = false,
  hideMenu = false,
  onAddNew = () => Promise.resolve(true),
}: DataTableConfig) {
  const { actions, filter, selection, modal, resource } = useResource<T>();

  const generateCSVData = (items: T[]) => {
    if (items.length === 0) return [];

    const data = items.map(item => {
      const { company, ...rest } = item as any;
      return rest;
    });

    const headers = Object.keys(data[0]);
    const rows = data.map(item => Object.values(item));
    return [headers, ...rows];
  };

  const handleCreateNew = async () => {
    if (await onAddNew()) {
      modal.handleOpenModal();
    }
  };

  return (
    <Flex justifyContent="space-between" alignItems="center" gap={2}>
      <Heading size="md" flexGrow={1}>
        {hideHeader || resource.title}
      </Heading>
      <Flex gap={2} alignItems="center">
        {!hideSearch && (
          <InputSearch
            size="sm"
            value={filter.text}
            onChange={e => filter.setText(e.target.value)}
          />
        )}
        <Button variant="white" size="sm" textTransform="capitalize" onClick={handleCreateNew}>
          {`New ${resource.name}`}
        </Button>
        {!hideMenu && (
          <Flex justifyContent="center" color="gray.200">
            <Menu>
              <MenuButton aria-label="Options" w="32px" h="32px">
                <FontAwesomeIcon icon={["far", "ellipsis-vertical"]} />
              </MenuButton>
              <MenuList>
                <MenuItem icon={<RepeatIcon />} onClick={() => actions.refetch()}>
                  Refresh
                </MenuItem>

                {selection.selectedItems.length > 0 && (
                  <CSVLink
                    data={generateCSVData(selection.selectedItems)}
                    filename={`${resource.title}.csv`}
                  >
                    <MenuItem icon={<DownloadIcon />}>Export</MenuItem>
                  </CSVLink>
                )}
              </MenuList>
            </Menu>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}
